<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-12">
        <div class="content">
          <div :id="id" ref="editor"></div>
        </div>
      </div>
      <div v-if="!hideButtons" class="column is-12">
        <div class="buttons">
          <button
            class="button"
            :class="[saveBtnStyle, { 'is-loading': loading }]"
            :disabled="loading"
            @click="!loading && $emit('save', GetHTML())"
          >
            {{ saveBtnName }}
          </button>

          <button
            class="button"
            :class="[cancelBtnStyle]"
            @click="$emit('cancel')"
          >
            {{ cancelBtnName }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic/build/ckeditor.js";

export default {
  components: {},
  props: [
    "html",
    "saveBtnName",
    "saveBtnStyle",
    "cancelBtnName",
    "cancelBtnStyle",
    "loading",
    "hideButtons"
  ],
  data() {
    return {
      ready: false,
      editor: null,
      id: Math.random()
        .toString(36)
        .substring(7)
    };
  },
  created() {},
  mounted() {
    this.Init();
  },
  beforeDestroy() {
    this.editor = null;
  },
  methods: {
    Init() {
      setTimeout(async () => {
        let el = document.getElementById(this.id);
        this.editor = await ClassicEditor.create(el, {
          // removePlugins: ["ImageUpload", "MediaEmbed"],
          toolbar: [
            "heading",
            "|",
            "bold",
            "italic",
            "link",
            "|",
            "bulletedList",
            "numberedList",
            "outdent",
            "indent"
          ],

          heading: {
            options: [
              {
                model: "paragraph",
                title: "Paragraph",
                class: "ck-heading_paragraph"
              },
              {
                model: "heading1",
                view: {
                  name: "h1",
                  classes: "title"
                },
                title: "Heading 1",
                class: "ck-heading_heading1"
              },
              {
                model: "heading2",
                view: {
                  name: "h2",
                  classes: "title"
                },
                title: "Heading 2",
                class: "ck-heading_heading2"
              },
              {
                model: "heading3",
                view: {
                  name: "h3",
                  classes: ["title", "is-4"]
                },
                title: "Heading 3",
                class: "ck-heading_heading3"
              },

              {
                model: "heading4",
                view: {
                  name: "h4",
                  classes: ["title", "is-5"]
                },
                title: "Heading 4",
                class: "ck-heading_heading4"
              },

              {
                model: "headinghero1",
                view: {
                  name: "h1",
                  classes: ["title", "is-size-1-desktop"]
                },
                title: "Hero Heading 1",
                class: "ck-heading_heading1"
              },

              {
                model: "headinghero2",
                view: {
                  name: "h2",
                  classes: ["title", "is-size-2-desktop"]
                },
                title: "Hero Heading 2",
                class: "ck-heading_heading2"
              },

              {
                model: "headinghero3",
                view: {
                  name: "h3",
                  classes: ["title", "is-size-3-desktop"]
                },
                title: "Hero Heading 3",
                class: "ck-heading_heading3"
              },

              {
                model: "span",
                view: {
                  name: "span",
                  classes: ""
                },
                title: "Inline",
                class: ""
              }
            ]
          }
        });

        if (this.html) {
          this.SetHTML(this.html);
        }

        this.$emit("ready");
      }, 50);
    },
    SetHTML(html) {
      this.editor.setData(html);
    },
    GetHTML() {
      let data = this.editor.getData().replace(/&nbsp;/gi, " ");
      return data;
    }
  }
};
</script>
